export const brandProfileConstants = {
  FETCH_BRAND_RESTAURANT: "FETCH_BRAND_RESTAURANT",
  FETCH_BRAND_PROFILE: "FETCH_BRAND_PROFILE",
  GET_BRAND_LOCATIONS: "GET_BRAND_LOCATIONS",
  FETCH_BRAND: "FETCH_BRAND",
  INITIAL_CONDITION: "GuestSentiments > 0",
  USER_ROLE: "User",
  ROLE: "Role",
  AND: " AND ",
  OR: " OR ",
  STATE: "state",
  NAME: "name",
  OWNER_NAME: "ownerName",
  GROUP_NAME: "group.name",
  LOCATION_STATE: "locationState",
};
